<template>
	<el-row>
		<el-button type="infor" @click="add">新增+</el-button>
		<el-table :data="tableDate" border style="width: 850px;margin: 0 auto;">
			<el-table-column label="id" prop="dicId" width="100px"></el-table-column>
			<el-table-column label="应用场景" prop="dicDesc" width="500px"></el-table-column>
			<el-table-column label="操作" width="200px">
				<template slot-scope="scope">
					<el-button @click="bj(scope.row)" type="text">编辑</el-button>
					<el-button @click="del(scope.row)" type="text" style="color: red;">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="width: 500px;margin: 20px auto;">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" @close="gb" width="30%" center>
			<el-form label-position="right" label-width="90px" :model="info" :rules="infoRules" ref="info">
				<el-form-item label="应用场景:" maxlength="20" prop="dicDesc">
					<el-input v-model="info.dicDesc" size="medium" style="width: 400px">
					</el-input>
				</el-form-item>
				<el-form-item label-width="180px">
					<el-button type="primary" @click="queren">确 定</el-button>
					<el-button @click="centerDialogVisible = false">取 消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>
<script>
	export default {
		data() {
			return {
				info: {
					dicDesc: '',
					dicId: ""
				},
				infoRules: {
					dicDesc: [{
						required: true,
						message: '请输入应用场景',
						trigger: 'change'
					}]
				},
				centerDialogVisible: false,
				title: '',
				tableDate: [],
				total: 0,
				pageNum: 1,
				pageSize: 20,
				pagelist: [20, 50, 100],
			}
		},
		methods: {
			add() {
				this.centerDialogVisible = true
				this.title = '添加应用场景'
				this.info.dicDesc = ''
			},
			gb() {
				this.getInfo()
			},
			bj(row) {
				this.info.dicDesc = row.dicDesc
				this.centerDialogVisible = true
				this.info.dicId = row.dicId
				this.title = '编辑应用场景'
			},
			del(row) {
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get(`/api/setting/paiBoCategory/deletePaiBoCategory?dicId=${row.dicId}`, {}).then(
						res => {
							if (res.data.data == 1) {
								this.$message.success(res.data.msg)
							} else {
								this.$message.error(res.data.msg)
							}
							this.getInfo()
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			queren() {
				this.$refs.info.validate(valid => {
					if (valid) {
						if (this.title == '添加应用场景') {
							this.$http.post(`/api/setting/paiBoCategory/addPaiBoCategory`, {
								"dicDesc": this.info.dicDesc,
								"dicModular": 33,
							}).then(res => {
								if (res.data.data == 1) {
									this.$message.success(res.data.msg)
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error(res.data.msg)
								}
							})
						} else if (this.title == '编辑应用场景') {
							this.$http.post(`/api/setting/paiBoCategory/updatePaiBoCategory`, {
									"dicDesc": this.info.dicDesc,
									"dicId": this.info.dicId,
								})
								.then(res => {
									if (res.data.data == 1) {
										this.$message.success(res.data.msg)
										this.centerDialogVisible = false
										this.getInfo()
									} else {
										this.$message.error(res.data.msg)
									}
								})
						}
					}
				})
			},
			getInfo() {
				this.$http.post(
					`/api/setting/paiBoCategory/selectPaiBoCategory?pageNum=${this.pageNum}&pageSize=${this.pageSize}`, {
						"dicModular": 33
					}).then(res => {
					console.log(res);
					// this.info.parentId = res.data.data.list[0].parentId
					this.total = res.data.data.total
					this.tableDate = res.data.data.list
					console.log(this.tableDate);
				});
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				this.getInfo()
			},
		},
		created() {
			this.getInfo()
		}
	}
</script>
<style scoped="scoped">

</style>
